import { render, staticRenderFns } from "./BookingHost.vue?vue&type=template&id=2211b1be&scoped=true&"
import script from "./BookingHost.vue?vue&type=script&lang=js&"
export * from "./BookingHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2211b1be",
  null
  
)

export default component.exports